import { isNull, reject } from 'lodash';

window.filterOutNullProperties = (props) =>
  Object.fromEntries(
    reject(Object.entries(props || {}), ([_k, v]) => isNull(v))
  );
